import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MenuItemDefinition } from '../../../model/menu-item-definition';
import { CommandDispatcher } from '../../../service/command/command-dispatcher.service';
import { CommandFactoryService } from '../../../service/factory/command-factory.service';

@Component({
    selector: 'app-context-menu-inline',
    templateUrl: './context-menu-inline.component.html',
    styleUrls: ['./context-menu-inline.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContextMenuInlineComponent<TContext = any> implements OnInit {
  constructor(
    private _commandDispatcher: CommandDispatcher,
    private _commandFactory: CommandFactoryService<TContext>
  ) {}

  @Input() context: TContext;
  @Input() menuDefinition: MenuItemDefinition<TContext>[];
  @Input() show: boolean;
  @Input() isEdit: boolean;

  @Input() contextId?: string;

  editItem: MenuItemDefinition<TContext>;
  menuItems: MenuItemDefinition<TContext>[];

  ngOnInit() {
    if (this.isEdit) {
      let isEditItems = this.menuDefinition.filter(item => item && item.isEdit);
      if (isEditItems && isEditItems.length > 0) {
        this.editItem = isEditItems[0];
      }
    } else {
      this.menuItems = this.menuDefinition.filter(item => item && !item.isEdit);
    }
  }

  onClicked(name: string) {
    let command = this._commandFactory.createContextCommand(name, this.context, this.contextId);
    this._commandDispatcher.sendCommand(command);
  }
}
